module.exports = {
    "Notifications": "Notifications",
    "You have received %1 tokens from": "vous a offert %1 jetons!",
    "You have received": "vous a offert",
    "has sent you": "vous a offert",
    "%1 tokens": "%1 jetons!",
    "%1 tokens privately!": "%1 jetons en privé!",
    "from": "",

    "has sent you a": "vous a envoyé un",
    "has given you a virtual gift!": "vous a offert un cadeau virtuel!",
    "has given you a": "vous a offert un",
    "virtual gift!": "cadeau virtuel!",
    "You have a new": "de s'abonner",
    "follower": "à votre compte.",
    "You have a new follower": "vient de s'abonner à votre compte.",

    "You have a new message at your Guest book from": "a rédigé un message sur votre livre d'or.",
    "You have a": "a rédigé un",
    "at your Guest book from" : "sur votre livre d'or.",

    "has sent you a new message.": "vous a envoyé un nouveau message.",
    "has given you an XXL membership for %1 days!": "vous a offert un abonnement XXL de %1 jours!",

    "XXL membership" : "abonnement XXL",
    "for %1 days!": "de %1 jours!",

    "has given an XXL membership to": "a offert un abonnement XXL à",
    "has posted at the Wall": "a posté sur le Mur",
    "has posted at": "a posté sur",
    "the Wall": "le Mur",
    "See all": "Voir tout",
    "just connected to the room": "vient de se connecter sur",
    "has opened a room My BobTV": "a ouvert une salle My BobTV",
    "started show My BobTV": "fait un show sur My BobTV",
    "Your XXL membership has expired at %1.": "Votre XXL a expiré le %1.",
    "Your XXL membership will expire at %1.": "Votre XXL va expirer le %1.",
    "Renew now!": "Renouvelez-le dès maintenant!",
    "new message": "nouveau message",

    "Here you can see all notifications or choose what notifications you want to receive. Or do not receive anything at all."
        : "Dans les paramètres sélectionnez les notifications que vous souhaitez recevoir sur le site et par émail.",
    "Settings": "Paramètres",
    "Notifications settings": "Paramètres de notification",
    "You will receive notifications at": "Les notifications sont envoyées sur",
    "Change email address": "Changer d'adresse émail",

    "When others start following me:": "Quand un membre me suit :",
    "When a followed user is connected:": "Quand un utilisateur auquel je suis abonné se connecte :",
    "When I receive a new message in my Inbox:": "Quand je reçois un nouveau message :",
    "When I receive a message in my guestbook:": "Quand un message est posté sur mon livre d'or :",

    "When I receive tokens:": "Quand je reçois des jetons :",
    "When I receive virtual gift:": "Quand je reçois un cadeau virtuel :",
    "When I receive Bobstore gift:": "Quand je reçois un cadeau Bobstore :",
    "When I receive an XXL membership gift:": "Quand je reçois un abonnement XXL :",

    "When new photo or video is posted on The Wall:": "Quand un nouveau média est posté sur le mur :",
    "Notify me on site": "me notifier sur le site.",
    "Notify me by email": "me notifier par émail.",

    "Notification services": "Service de notifications",
    "No notifications at the moment.": "Aucune notification pour le moment.",
    
    "There was a problem with recording of your video clip." : "Un problème est survenu lors de l'enregistrement de votre clip vidéo.",
};



// WEBPACK FOOTER //
// ./src/l10n-messages/fr/notifications.js